import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../utils/dateUtils';
import { useAuth } from '../../context/AuthContext';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const AuctionCard = ({ auction }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleCardClick = () => {
    const isSystemAuction = auction.id.toString().startsWith('system_');
    const path = isSystemAuction ? 
      `/auctions/system/${auction.id.replace('system_', '')}` : 
      `/auctions/${auction.id}`;
    navigate(path);
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-md p-4"
      onClick={handleCardClick}
    >
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm font-medium text-gray-900">{auction.name}</p>
          <p className="text-sm text-gray-500">{auction.auction_house_name}</p>
          <p className="text-sm text-gray-500">{formatDate(auction.start_date, { user })}</p>
        </div>
        <div className="text-right">
          <p className="text-sm text-gray-500">{auction.lot_count} lots</p>
        </div>
      </div>
    </div>
  );
};

export default AuctionCard;
